module.exports = __webpack_public_path__ + "static/media/tg6.090e45f3.jpg";